interface ICosmeticsStructureItem {
  id: number
  name: string
  pageTitle: string
  description: string
  url: string
  groupedProducts: boolean
  productsQuery: {
    groups: string[]
    types: string[]
    gender: 'female' | 'male' | 'unisex'
    productsFeed: string
  }
  seo: {
    title: string
    description: string
  }
  analytics: {
    page: string
    placement: string
  }
  children: ICosmeticsStructureItem[]
}

interface IModifyCosmeticsStructure {
  rootCatalogue: ICosmeticsStructureItem
}

interface ICosmeticsStructureResult extends ICosmeticsStructureItem {
  root: string
  brandsQuery?: {
    groups?: string[]
    types?: string[]
    gender?: 'female' | 'male' | 'unisex'
  }
}

interface IModifyCosmeticsStructureResult {
  [key: string]: ICosmeticsStructureResult
}


const modifyCosmeticsStructure = ({ rootCatalogue }: IModifyCosmeticsStructure): IModifyCosmeticsStructureResult => {
  const processChildren = (children: ICosmeticsStructureItem, root: string) => {
    if (children.children && children.children.length) {
      children.children = children.children.map((ch) => processChildren(ch, root))
    }
    else {
      delete children.children
    }

    return {
      ...children,
      root,
      brandsQuery: {
        groups: children.productsQuery.groups,
        types: children.productsQuery.types,
        gender: children.productsQuery.gender,
      },
    }
  }

  return rootCatalogue.children.reduce((result, children) => ({
    ...result,
    [children.name]: children.children.map((ch) => processChildren(ch, children.name)),
  }), {})
}


export default modifyCosmeticsStructure
